<template lang="html">
  <div class="animaldetail">
    <div class="animaldetail--header">
      <h1>{{animal.name}}

          <v-btn v-if="animal.animal_of_week" class="mx-2" fab dark small color="pink">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon dark v-on="on">mdi-heart</v-icon>
              </template>
              <span>A hét védence!</span>
            </v-tooltip>
          </v-btn>

          <div v-if="animal.colorcode" class="mx-2 colorcoded-icons">
            <v-tooltip v-if="animal.colorcode==='green'" bottom>
              <template v-slot:activator="{ on }">
                <v-icon large  :color="animal.colorcode" v-on="on">mdi-check-bold</v-icon>
              </template>
              <span v-text="colorcodes[animal.colorcode]"></span>
            </v-tooltip>

            <v-tooltip v-else-if="animal.colorcode==='pink'" bottom>
              <template v-slot:activator="{ on }">
                <v-icon large  :color="animal.colorcode" v-on="on">mdi-cash-usd-outline</v-icon>
              </template>
              <span v-text="colorcodes[animal.colorcode]"></span>
            </v-tooltip>

            <v-tooltip v-else-if="animal.colorcode==='black'" bottom>
              <template v-slot:activator="{ on }">
                <v-icon large  :color="animal.colorcode" v-on="on">mdi-emoticon-sad</v-icon>
              </template>
              <span v-text="colorcodes[animal.colorcode]"></span>
            </v-tooltip>

            <v-tooltip v-else bottom>
              <template v-slot:activator="{ on }">
                <v-icon large :color="animal.colorcode" v-on="on">mdi-alert-circle</v-icon>
              </template>
              <span v-text="colorcodes[animal.colorcode]"></span>
            </v-tooltip>
          </div>

      </h1>

      <v-row v-if="permAddNew || permMod || permDel" class="animaldetail--administration" justify=center>
        <v-col cols="12" md="10" lg="8">
          <v-btn @click="makeAnimalOfWeek(animal.id)" rounded v-if="!animal.animal_of_week && permAddNew" class="pink ma-2">
            Legyen a hét kedvence!
          </v-btn>
          <v-btn @click="update(animal.id)" rounded v-if="permMod" class="warning ma-2">
            Módosítom az adatokat
          </v-btn>
          <v-btn @click="showDeleteWarning=true" rounded v-if="permDel" class="error ma-2">
            Törlöm ezt a védencet!
          </v-btn>
        </v-col>

        <DeleteWarning
          :showDialog="showDeleteWarning"
          @deleteCancelled="showDeleteWarning=false"
          @deleteConfirmed="deleteConfirmed(animal.id)" />
      </v-row>

    </div>
    <v-row class="animaldetail--main-image" justify=center>
      <v-col cols="12" md="10" lg="8">
        <v-img :src="selectedImage ? selectedImage : animal.mainImage"></v-img>
      </v-col>
    </v-row>
    <v-row justify=center class="animaldetail--smallpics">
      <v-col cols="10" md="6">
        <v-avatar
          v-if="animal.image2"
          @click="imageSelected(animal.mainImage)">
          <img :src="animal.mainImage"/>
        </v-avatar>
        <v-avatar
          v-if="animal.image2"
          @click="imageSelected(animal.image2)">
          <img :src="animal.image2"/>
        </v-avatar>
        <v-avatar
          v-if="animal.image3"
          @click="imageSelected(animal.image3)">
          <img :src="animal.image3"/>
        </v-avatar>
      </v-col>
    </v-row>
    <v-row justify=center class="animaldetail--info">
      <v-col cols="12" md="10" lg="8">
        <v-card>
          <v-card-title>{{animal.name}} adatlapja</v-card-title>
          <v-card-text>
            <p class="animaldetail--info__tag">Azonosító:<span>{{animal.shelterID}}</span></p>
            <p class="animaldetail--info__tag">Neve: <span>{{animal.name}}</span></p>
            <p class="animaldetail--info__tag">Faja: <span>{{animal.species}}</span></p>
            <p class="animaldetail--info__tag">Kora: <span>{{animal.age}}</span></p>
            <p class="animaldetail--info__tag">Ivara: <span>{{animal.gender}}</span></p>
            <p class="animaldetail--info__tag">Fajtája: <span>{{animal.breed}}</span></p>
            <p class="animaldetail--info__tag">Súlya: <span>{{animal.size}}</span></p>
            <p class="animaldetail--info__tag">Bekerülés időpontja: <span>{{animal.date_of_arrival}}</span></p>
            <p class="animaldetail--info__tag">Örökbefogadható: <span v-text="animal.adoptable ? 'igen' : 'nem'"></span></p>
            <p v-if="animal.social_link_string" class="animaldetail--info__tag"><a :href="animal.social_link_string" target="_blank">Facebook info: <v-icon>mdi-facebook</v-icon></a></p>
            <p v-if="animal.documents_link_string" class="animaldetail--info__tag"><a :href="animal.documents_link_string" target="_blank">Dokumentumok <v-icon color="brown">mdi-folder-settings</v-icon></a></p>
            <p v-if="animal.adopted" class="animaldetail--info__tag">Örökbefogadás időpontja: <span>{{animal.date_of_adoption}}</span></p>
            <p class="animaldetail--info__tag">Megjegyzés: <span>{{animal.other}}</span></p>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col v-if="animal.story" cols="12" md="10" lg="8" class="animalstory">
        <v-card>
          <v-card-title>{{animal.name}} története</v-card-title>
          <v-card-text>
            <p>{{animal.story}}</p>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import axios from 'axios';
import {colorcodes} from './colorcodes.js';

import DeleteWarning from '@/components/Administration/DeleteWarning.vue'

export default {
  data(){
    return{
      selectedImage: '',
      showDeleteWarning: false,
      colorcodes,
    }
  },
  computed:{
    animal(){
      return this.$store.getters.animalById(this.$route.params.id)
    },
    permMod(){
      return this.$store.getters.hasPermissionToChange
    },
    permDel(){
     return this.$store.getters.hasPermissionToDelete
    },
    permAddNew(){
     return this.$store.getters.hasPermissionToAddNew
    },
    token(){
      return this.$store.getters.token
    }

  },
  methods:{
    imageSelected(imgUrl){
      this.selectedImage = imgUrl
    },
    deleteConfirmed(id){
      axios.delete(`api/update-animals/${id}/`, {headers:{'Authorization': `Token ${this.token}`}})
      .then(res=>{
        this.$store.dispatch('setAnimals');
        this.$router.push('/');
      })
      .catch(err=>{
        console.log(err);
        this.$router.push('/');
      })
    },
    update(id){
      this.$router.push(`/administration/update/${id}`)
    },
    makeAnimalOfWeek(id){
      axios.get(`api/update-animals/${id}/make_animal_of_week/`, {headers:{'Authorization': `Token ${this.token}`}})
      .then(res=>{
        this.$store.dispatch('setAnimals');
      })
    }
  },
  components:{
    DeleteWarning,
  },
  created(){
    window.scrollTo(0,0);
  }
}
</script>

<style lang="scss" scoped>
.animaldetail{
  width: 95%;
  margin: 0 auto;
}
.animaldetail--header{
  text-align: center;
  margin: 20px;
}

.animaldetail--smallpics{
  text-align: center;

  .v-avatar{
    margin: 0 10px;
  }
}

.animaldetail--info{
  .v-card{
    background-color:$cardbackground;
  }
}

.v-application p{
  margin-bottom: 3px;
}

.v-card__text{
  font-size: 1rem;
}

.animaldetail--info__tag{
  font-weight: bold;

  span{
    font-weight: normal;
    display: inline-block;
    margin-left: 5px;
  }
}

.colorcoded-icons{
  display: inline-block;
}

.animalstory p{
  text-align: justify;
}

.animaldetail--info__tag a{
  text-decoration: none;
}
</style>
